import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import axiosApi from '@/request/index'
import {getToken, setToken, removeToken} from "@/utils/auth";
// import {loginDing} from "@/api/login";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    pageType: 0,
    token: getToken(),
    menus:[],
    menusOver:false,
    routeNow:{},
    defultValue:[],
    adminFlag:'',
    openId:'',
    historyRoute:{},
    btnList:[]
  },
  modules: {},
  getters,
  mutations: {
    savePageType(state, pageType) {
      state.pageType = pageType;
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_MENUOVER: (state, menusOver) => {
      state.menusOver = menusOver
    },
    SET_ROUTENOW: (state, routeNow) => {
      state.routeNow = routeNow
    },
    SET_DEFULT: (state,defultValue) => {
      state.defultValue = defultValue
    },
    SET_ADMINFLAG: (state,adminFlag) => {
      state.adminFlag = adminFlag
    },
    SET_OPENID: (state,openId) => {
      state.openId = openId
    },
    SET_HISTORY: (state, route) => {
      state.historyRoute = route
      // state.routers = routers
    },
    SET_BTNLIST: (state, btnList) => {
      state.btnList = btnList
      // state.routers = routers
    },
  },
  actions:{
    dingLogin({commit}, token) {
      console.log(token)
      var params = {authCode:token}
      return new Promise((resolve, reject) => {
        // setToken('1111')
        // commit('SET_TOKEN', '1111')
        // resolve()
        axiosApi.loginDing(params).then(res => {
          setToken(res.content.token)
          commit('SET_TOKEN', res.content.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
        // loginDing(params).then(response => {
        //   console.log(response)
        //   if(!response.content.token){
        //     reject(error)
        //   }
        //
        // }).catch(error => {
        //   reject(error)
        // }
      })
    },
    // 获取用户菜单权限
    GetUserMenus({commit, state}) {
      return new Promise((resolve, reject) => {
        axiosApi.getMenus().then(response => {
          var list = response.content.permissionInfo
          var menus = []
          var btnList = []
          if(list&&list.length>0){
            for (var ind in list) {
              if(list[ind].children&&list[ind].children.length>0){
                menus=menus.concat(list[ind].children)
                for(var ind1 in list[ind].children){
                  if(list[ind].children[ind1].requestUrlList&&list[ind].children[ind1].requestUrlList.length>0){
                    btnList = btnList.concat(list[ind].children[ind1].requestUrlList.map((item)=>{return item.id}))
                  }
                }
              }
            }
          }
          // commit('SET_ROLES', [response.user.role_info.name])
          commit('SET_MENUS', menus)
          commit('SET_BTNLIST', btnList)
          commit('SET_ADMINFLAG', response.content.adminFlag||'')
          commit('SET_DEFULT', response.content.pageDefaultValue||[])
          commit('SET_MENUOVER', true)
          resolve()
        }).catch(error => {
          console.log('---- menus ----', error)
          reject(error)
        })
      })
    },
    loadWxUnionId({commit, state},code){
      var params = {code:code,appid:'wx884fad7e2cebff9e'}
      return new Promise((resolve, reject) => {
        axiosApi.wechatAccess(params).then(response => {
          if(response.content.token){
            setToken(response.content.token)
            commit('SET_TOKEN', response.content.token)
          }
          // console.log('111')
          resolve(response.content)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js